import { InputFieldProps } from "./types";

export const BooleanInput: React.FC<InputFieldProps> = ({ inputValue, onUpdate }) => (
	<div className="flex align-center">
		<label className="">
			<input
				onChange={(e) => onUpdate?.(!!e.target.checked)}
				type="checkbox"
				checked={inputValue || false}
				className="rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
			/>
		</label>
	</div>
);
